
        import Symbol from "../../../svg-baker-runtime/browser-symbol.js";
        import sprite from "../../../svg-sprite-loader/runtime/browser-sprite.build.js";

        const symbol = new Symbol({
  "id": "icon-material-arrow_selector_tool",
  "use": "icon-material-arrow_selector_tool-usage",
  "viewBox": "0 -960 960 960",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 -960 960 960\" id=\"icon-material-arrow_selector_tool\"><path d=\"M301.43-353.93 407.8-503.11h213.7l-320.07-251.5zM563.35-69.65 412.48-392.39 233.3-141.11v-753.48l585.11 459.85H510.98l148.11 320.46zM407.8-503.11\" /></symbol>"
});
        sprite.add(symbol);

        function Icon({...props}) {
            return (
                <svg {...props} className="icon" fill="currentColor">
                    <use xlinkHref="#icon-material-arrow_selector_tool"/>
                </svg>
            );
        };

        Icon.id = "icon-material-arrow_selector_tool";

        export default Icon;
    